import { render, staticRenderFns } from "./dashboard-product-tips.vue?vue&type=template&id=3fe6a61a&"
import script from "./dashboard-product-tips.vue?vue&type=script&lang=js&"
export * from "./dashboard-product-tips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports